<template>
    <div class="nav-bar-wrapper">
        <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">
        <!--White space to account for nav bar-->
        <div class="white-space"></div>
        <ul id="nav-bar" class="fadable nav-bar-opened">
            <li> 
                <a>
                <router-link to="/" style="padding:0px" id="home-button">
                <div style= " width:2rem; height: 2rem; background-color: gray;  border-radius: 50%; position:relative; top:-0.5rem">
				<i class="material-icons" style="position:relative; top:+0.15rem;">home</i>
                </div>
                </router-link>
                </a>
            </li>
            <li v-for="(secElement, index) in this.sectionElements" :key="index">
                <a id="section-button" @click="secElement.scrollIntoView({ behavior: 'smooth' })">{{secElement.textContent}}</a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props:{
        //Elements of the subheading
        sectionElements:{
           default: function(){return []},
           type: Array
       },
    },
    data:function(){
        return{
            lastPosition: 0,
            navBarOpen: true,
        }
    },
    methods: {
    handleScroll () {
        let currentPosition = window.pageYOffset
        if(this.lastPosition > currentPosition){
            //scrolling up
            if(this.navBarOpen == false){
                //open nav-bar
                let navBarEl = document.getElementById("nav-bar")
                navBarEl.classList.remove("nav-bar-closed");
                navBarEl.classList.add("nav-bar-opened");
                this.navBarOpen = true
            }
        }else{
            //scrolling down
            if(this.navBarOpen == true){
                //close nav-bar
                let navBarEl = document.getElementById("nav-bar")
                navBarEl.classList.remove("nav-bar-opened");
                navBarEl.classList.add("nav-bar-closed");
                this.navBarOpen = false
            }
        }
        this.lastPosition = currentPosition
    }
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>

<style  scoped>
    /*Do not display nav bar on movile*/
    @media screen and (max-width: 600px) {
        .nav-bar-wrapper{
            display:none;
        }
    }
    .white-space{
        height: 3rem;
    }
    /*Used in nav bar*/
    .fadable{
        transition: 0.3s;
        transition-timing-function: ease;
    }
    .nav-bar-opened{
        top: 0px;
    box-shadow: rgba(88, 88, 88, 0.5) 0px 10px;
    }
    .nav-bar-closed{
        top: -3rem;
        box-shadow: rgba(88, 88, 88, 0.5) 0px 0px;

    }
    #nav-bar {
    position: fixed;
    z-index: 10;
    width: 100%;
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    background-color: #333;
    }

    li {
    float: left;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    }

    li a {
    height: 1rem;
    font-size: 1rem;
    color:rgba(255,255,255,.5);
    justify-content: center; /* align horizontal */
                align-items: center; /* align vertical */
    display: block;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    }
    #section-button{
            color:rgba(255,255,255,.5);
    }
    #section-button:hover {
        color: #f0f0f0;
        cursor:pointer;
    }
    #home-button{
         color:#333;
    }
    #home-button:hover{
        color: #f0f0f0;
    }
</style>